import {Injectable} from "@angular/core";
import * as Sentry from "@sentry/angular";
import {BaseCommandMessage, COMMAND_PING} from 'shared/commands';
import {environment} from "../../environments/environment";
import {isInBrowser} from "../utils/clientutils";


@Injectable({
    providedIn: 'root'
})
export class TransportService {
    //TODO: Стоит добавить возможность добавлять middleware или interceptors чтоб можно было работать с запросами и ответами

    private ws: WebSocket;

    private onConnectCallback: (this: TransportService) => void;
    private onDisconnectCallback: (this: TransportService, statusCode: number) => void;
    private onMessageCallback: (this: TransportService, message: MessageEvent) => void;
    private onErrorCallback: (this: TransportService) => void;

    private timer: number;

    constructor() {
    }

    private get host(): string {
        return environment.websocket
    }

    connect(parameters: ConnectParameters) {
        if (!isInBrowser()) return
        try {
            let params = parameters.map((value) => {
                return `${value.name}=${encodeURIComponent(value.value)}`
            }).join('&')

            this.ws = new WebSocket(`${this.host}/?${params}`);

            this.subscribeOnSocket()
        } catch (error) {
            this.ws = null;
            Sentry.captureException(error, {
                tags: {
                    "transport": "connect",
                    "url": this.host,
                },
                extra: {
                    "url": this.host,
                }
            });
            this.onErrorCallback();
        }
    }

    onConnect(callback: ((this: TransportService) => void)) {
        if (this.onConnectCallback) {
            console.warn(new Error("onConnect callback already set"))
        }

        this.onConnectCallback = callback
    }

    onDisconnect(callback: ((this: TransportService, statusCode: number) => void)) {
        if (this.onDisconnectCallback) {
            console.warn(new Error("onDisconnect callback already set"))
        }

        this.onDisconnectCallback = callback
    }

    onError(callback: ((this: TransportService) => void)) {
        if (this.onErrorCallback) {
            console.warn(new Error("onError callback already set"))
        }

        this.onErrorCallback = callback
    }

    onMessage(callback: ((this: TransportService, message: object) => void)) {
        if (this.onMessageCallback) {
            console.warn(new Error("onMessage callback already set"))
        }

        this.onMessageCallback = callback
    }

    sendMessage(message: any) {
        const jsonMessage = JSON.stringify(message);
        if (!environment.production) {
            //console.log('<-', jsonMessage);
        }
        this.ws.send(jsonMessage);
    }


    isConnected(): boolean {
        return this.ws && this.ws.readyState === WebSocket.OPEN;
    }

    disconnect() {
        try {
            this.ws.close();
        } catch (ignore) {

        }

        this.ws = null;
    }

    private subscribeOnSocket() {
        this.ws.onmessage = (event: MessageEvent) => {
            if (this.onMessageCallback) {
                if (!environment.production) {
                    //console.log('->', event.data);
                }

                let data: any;
                try {
                    data = JSON.parse(event.data);
                } catch (error) {
                    this.ws.close();
                    return;
                }

                if (this.onMessageCallback) {
                    this.onMessageCallback(data);
                }
            }
        };

        this.ws.onclose = (event: CloseEvent) => {
            this.ws = null;

            this.stopPingTimer();
            if (this.onDisconnectCallback) {
                this.onDisconnectCallback(event.code)
            }
        };

        this.ws.onerror = (_: ErrorEvent) => {
            if (this.onErrorCallback) {
                this.onErrorCallback();
            }
        };

        this.ws.onopen = (_: Event) => {
            this.startPingTimer();

            if (this.onConnectCallback) {
                this.onConnectCallback()
            }
        };
    }

    private startPingTimer() {
        //TODO: Перенести ping timer в remote command service

        const _this = this;

        if (isInBrowser()) {
            this.timer = window.setInterval(function () {
                _this.sendPing();
            }, 5_000);
        }
    }

    private stopPingTimer() {
        clearInterval(this.timer);
    }

    private sendPing() {
        if (this.ws != null && this.isConnected()) {
            this.sendMessage(new BaseCommandMessage(COMMAND_PING));
        }
    }
}

export type ConnectParameters = Array<{ name: string, value: string }>

